import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
//
//
const API_KEY = process.env.REACT_APP_API_KEY as string;
//
export const apiSliceLatestMachinery = createApi({
    reducerPath: "latestMachineListApi",
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_HOST}`,
        prepareHeaders: (headers) => {
            headers.set("X-API-KEY", API_KEY);
            return headers;
        },
    }),
    tagTypes: ["latestmachinelistapi"],
    endpoints: (builder) => ({
        getLatestMachine: builder.query({
            query: (machine_id) => `/showroom/api/v1/product_list/?q=${machine_id}&filter_by_category=machine_category_id`,
            keepUnusedDataFor: 480,
            providesTags: ["latestmachinelistapi"],
            transformResponse: (response: any) => {
                return response.data
            }
        }),

    }),

});

//
export const { useGetLatestMachineQuery } = apiSliceLatestMachinery;
